import { render, staticRenderFns } from "./VenueInfo.vue?vue&type=template&id=28d8bc06&scoped=true&"
import script from "./VenueInfo.vue?vue&type=script&lang=js&"
export * from "./VenueInfo.vue?vue&type=script&lang=js&"
import style0 from "./VenueInfo.vue?vue&type=style&index=0&id=28d8bc06&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d8bc06",
  null
  
)

export default component.exports